/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import {Injectable} from '@angular/core';
import {XHR} from '../utils/xhr';

@Injectable()
export class PingRepo {

    private command: string  = 'spa-ping';

    constructor(private request: XHR) {}

    public knock_knock() {
        return this.request.post({
                command: this.command
        })
    };
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/repository/ping_repo.ts